import { ReactNode } from 'react';

import { CloseIcon } from '../ui/icons';

interface IModalConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  closeAriaLabel: string;
  dialogAriaLabel: string;
  containerClassName?: string;
  dialogClassName?: string;
  title: ReactNode;
  titleClassName?: string;
  icon?: ReactNode;
  iconClassName?: string;
  showHeaderCloseButton?: boolean;
  actions: ReactNode;
  children: ReactNode;
}

/** Примитивная модалка подтверждения без бизнес-логики и вызовов API. */
export default function ModalConfirm({
  isOpen,
  onClose,
  closeAriaLabel,
  dialogAriaLabel,
  containerClassName,
  dialogClassName,
  title,
  titleClassName,
  icon,
  iconClassName,
  showHeaderCloseButton = false,
  actions,
  children
}: IModalConfirmProps) {
  const containerClassNames = ['telegram-confirm', isOpen ? 'telegram-confirm--open' : '', containerClassName].filter(Boolean).join(' ');
  const dialogClassNames = ['telegram-confirm__dialog', dialogClassName].filter(Boolean).join(' ');
  const iconClassNames = ['telegram-confirm__icon', iconClassName].filter(Boolean).join(' ');
  const titleClassNames = ['telegram-confirm__title', titleClassName].filter(Boolean).join(' ');

  return (
    <div className={containerClassNames} aria-hidden={!isOpen}>
      <button
        className="telegram-confirm__backdrop"
        type="button"
        aria-label={closeAriaLabel}
        onClick={onClose}
      />

      <section className={dialogClassNames} role="dialog" aria-modal="true" aria-label={dialogAriaLabel}>
        <div className="telegram-confirm__glow" aria-hidden="true" />

        <div className="telegram-confirm__header">
          {icon ? <div className={iconClassNames}>{icon}</div> : null}
          <div className={titleClassNames}>{title}</div>
          {showHeaderCloseButton ? (
            <button className="telegram-confirm__close" type="button" onClick={onClose} aria-label={closeAriaLabel}>
              <CloseIcon width="24px" height="24px" color="currentColor" opacity="1" />
            </button>
          ) : null}
        </div>

        {children}

        <div className="telegram-confirm__actions">{actions}</div>
      </section>
    </div>
  );
}